import styled from 'styled-components';
import Card from '../../../common/Card';
export const ProgramTileContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;
  height: 100%;
`;
export const ProgramTileHeader = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;
`;
export const ProgramTileBody = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;
  height: 100%;
`;
export const ProgramCard = styled(Card) `
  width: ${({ $isWide }) => ($isWide ? 552 : 480)}px;
  min-height: 256px;
  height: 100%;
  max-width: 100%;
  .card-body {
    padding: ${({ $isWide }) => ($isWide ? '32px 48px' : '32px 24px')};
    height: 100%;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    width: 100%;
    .card-body {
      padding: 32px;
    }
  }
`;
